import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  close(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.hasFormTarget) {
      this.formTarget.reset();
    } else {
      const form = this.element.querySelector("form");
      if (form) {
        form.reset();
      }
    }

    if (this.element.tagName === "DETAILS") {
      this.element.open = false;
    } else {
      const details = this.element.closest("details");
      if (details) {
        details.open = false;
      }
    }
  }

  open() {
    if (this.element.tagName === "DETAILS") {
      this.element.open = true;
    } else {
      const details = this.element.closest("details");
      if (details) {
        details.open = true;
      }
    }
  }
}
